/**
 * The Guide — conversation API. One session per visit to the Learn page.
 *
 * Creating is all the page needs: the conversation lives for the visit and is
 * not rehydrated, so there is no client for `GET /guide/conversations/<id>`
 * here. The route itself stays — it is what replays which tutorials were
 * opened, and `scripts/journey/probe-guide-agent.py` exercises it.
 */

import api from '@/services/api';

export interface GuideConversation {
  conversation_id: string;
  conversation_kind: 'guide' | string;
  message_count: number;
  created_at: string;
}

export const guideApi = {
  /**
   * Open a Guide session.
   *
   * The catalog is NOT sent: the server builds it from its own copy of this
   * catalog (config/journey_catalog.json, generated from catalog.ts) and
   * filters it by the caller's real role and flags. It used to come from
   * here, which meant the browser was declaring its own permissions and
   * writing text straight into the Guide's prompt.
   */
  async createConversation(lang: 'en' | 'he'): Promise<GuideConversation> {
    const { data } = await api.post('/guide/conversations', { lang });
    return data as GuideConversation;
  },
};
